/* @flow */
import React from 'react';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import ActivityStore from 'payments/stores/ActivityStore';
import PaymentAccountStore from 'payments/stores/PaymentAccountStore';
import PaymentAccountActions from 'payments/actions/PaymentAccountActions';
import ConnectedBankAccountActions from 'payments/actions/ConnectedBankAccountActions';
import ConnectedBankAccountStore from 'payments/stores/ConnectedBankAccountStore';
import ActivitiesNotifications from 'payments/components/ActivitiesNotifications.jsx';

type State = {
  canCollectMoney: boolean,
  needToAddBankAccount: boolean,
  needAccountVerification: boolean,
  needAdditionalVerification: boolean,
  pendingBankAccountRequestsNumber: number,
};

class ActivitiesNotificationsContainer extends React.Component {
  state: State;

  static getStores() {
    return [
      CurrentUser,
      ActivityStore,
      PaymentAccountStore,
      ConnectedBankAccountStore,
    ];
  }

  static calculateState() {
    const paymentAccount = PaymentAccountStore.getPaymentAccount();
    const pendingBankAccountRequests = ConnectedBankAccountStore.getConnectedBankAccounts().filter(
      account => account.getCanManage() && account.isPending()
    );

    const isCollectingMoney: boolean = ActivityStore.getActivities().some(
      activity => activity.isSender() && !activity.isFree()
    );

    return {
      canCollectMoney: CurrentUser.getUser().canCollectMoney(),
      canCreateActivity: CurrentUser.getUser().canCreateActivity(),
      needAccountVerification: paymentAccount ? paymentAccount.needBasicVerification() && isCollectingMoney : false,
      needAdditionalVerification: paymentAccount ? paymentAccount.needAdditionalVerification() && isCollectingMoney : false,
      needToAddBankAccount: paymentAccount ? paymentAccount.needBankAccountVerification() : false,
      pendingBankAccountRequestsNumber: pendingBankAccountRequests.length,
    };
  }

  componentDidMount() {
    if (!PaymentAccountStore.getPaymentAccount()) {
      PaymentAccountActions.load();
    }

    ConnectedBankAccountActions.load();
  }

  render() {
    return (
      <ActivitiesNotifications
        refreshPaymentAccount={PaymentAccountActions.load}
        needToAddBankAccount={this.state.canCollectMoney && this.state.needToAddBankAccount}
        needAccountVerification={this.state.canCollectMoney && this.state.needAccountVerification}
        needAdditionalVerification={this.state.canCollectMoney && this.state.needAdditionalVerification}
        pendingBankAccountRequestsNumber={this.state.pendingBankAccountRequestsNumber}
      />
    );
  }
}

export default Container.create(ActivitiesNotificationsContainer);



// WEBPACK FOOTER //
// ./src/payments/containers/ActivitiesNotificationsContainer.jsx